var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-shape-dialog',{attrs:{"title":_vm._f("i18n")('room.param.shape.title'),"subtitle":_vm._f("i18n")('room.param.shape.subtitle'),"description":_vm._f("i18n")('room.param.shape.description')},model:{value:(_vm.shape),callback:function ($$v) {_vm.shape=$$v},expression:"shape"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f5e6f06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/RoomShapeDialog.vue
// module id = null
// module chunks = 